import TelemetryXRayGeneratorControllerHandle from 'app/adapters/XRayGenerator/TelemetryXRayGeneratorControllerHandle';
import EventEmitter from 'events';

export default class TelemetryXRayGeneratorControllerManager extends EventEmitter {
  constructor(xrayGeneratorManager, generatorConnectionCallback) {
    super();

    this.xrayGeneratorManager = xrayGeneratorManager;
    this.generatorConnectionCallback = generatorConnectionCallback;
  }

  list() {
    return this.xrayGeneratorManager
      ?.list()
      .then((xrayGeneratorHandles) =>
        xrayGeneratorHandles.map(
          (xrayGeneratorHandle) =>
            new TelemetryXRayGeneratorControllerHandle(
              xrayGeneratorHandle,
              this.generatorConnectionCallback
            )
        )
      );
  }

  get(devicePath) {
    return new TelemetryXRayGeneratorControllerHandle(
      this.xrayGeneratorManager.get(devicePath),
      this.generatorConnectionCallback
    );
  }
}
